import TYPES from '@/modules/shared/types';

// Domain
import { InvestorGoalRiskToleranceRepository }
  from '../../domain/repositories/investor-goal-risk-tolerance-repository';
import { InvestorGoalRiskToleranceDto }
  from '../../domain/dto/investor-goal-risk-tolerance-dto';
import { LowToleranceNotificationDto }
  from '../../domain/dto/low-tolerance-notification-dto';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import HttpConnector from '@/modules/shared/domain/connectors/http';

@Injectable()
export default class InvestorGoalRiskToleranceHttpRepository implements
  InvestorGoalRiskToleranceRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private readonly endpoint = `${process.env.VUE_APP_API_URL}/api/v1/app/flagship/investor-goal-risk-tolerance/`;

  update(investor_goal_risk_tolerance_dto: InvestorGoalRiskToleranceDto):
    Promise<void> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(this.endpoint, 'POST', investor_goal_risk_tolerance_dto)
        .then((response) => {
          response.json()
            .then(({ success, data, message }) => {
              if (success) {
                resolve(data);
              } else {
                reject(new Error(message));
              }
            });
        })
        .catch(reject);
    });
  }

  notify(low_tolerance_notification: LowToleranceNotificationDto): Promise<void> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(`${this.endpoint}low-tolerance-notification/moderate/`, 'POST', low_tolerance_notification)
        .then((response) => {
          response.json()
            .then(({ success, data, message }) => {
              if (success) {
                resolve(data);
              } else {
                reject(new Error(message));
              }
            });
        })
        .catch(reject);
    });
  }
}
